import React from 'react'
import { useParams } from 'react-router-dom'
import StackedAreaChart from '../../components/stackedareachart/StackedAreaChart'
import TopSchoolsTable from '../../components/topschoolstable/TopSchoolTable'
import TopWidgets from '../../components/topwidgets/TopWidgets'
const Block = () => {
    useParams()
  return (
    <div className="district">
      <h3 className='text-2xl m-3 font-sans font-light'>Block</h3>
        <TopWidgets/>
        <StackedAreaChart title="Usage Period" width="100%" aspect={7/2} />
        <TopSchoolsTable/>
      </div>
  )
}

export default Block